import * as React from 'react'
import { ICopyright } from './interface'
import { useTranslation } from 'react-i18next'
import './Copyright.scss'

const Copyright = ({ hideCopyRightText }: ICopyright) => {
  const { t } = useTranslation()
  const YEAR = new Date().getFullYear()
  const CONEKTA_NAME_BRAND_AND_YEAR = `© Conekta ${YEAR}`
  const COPY_RIGHT_TEXT = hideCopyRightText ? '' : ` – ${t('copyright')}`

  return (
    <div className='Copyright'>
      <p>{`${CONEKTA_NAME_BRAND_AND_YEAR}${COPY_RIGHT_TEXT}`}</p>
    </div>
  )
}

export default Copyright
